import { useEffect, useState } from 'react'
import { api, type Category } from '../lib/api'
import { CategoryGrid } from '../components/ProductGrid'

export function MinecoinPage() {
  const [items, setItems] = useState<Category[]>([])
  useEffect(() => {
    api.categories('tag=minecraft&limit=80').then((r) => {
      setItems(
        r.categories.filter(
          (c) => /minecoin/i.test(c.name) || c.group_id === 11 || /nạp/i.test(c.name),
        ),
      )
    })
  }, [])
  return (
    <>
      <h1 className="page-title">Minecoin</h1>
      <p className="page-lead">Gói nạp Minecoin — giao thủ công theo đơn.</p>
      <CategoryGrid items={items} />
    </>
  )
}
